import { ArrowRight, LifeBuoy, Mail, ReceiptText } from 'lucide-react';
import { Link } from 'react-router-dom';
import { SiteFooter } from '../components/SiteFooter';
import { SiteHeader } from '../components/SiteHeader';
import { siteDetails } from '../lib/site';

export const Contact = () => (
  <main className="min-h-screen bg-background text-foreground">
    <SiteHeader />
    <section className="mx-auto max-w-6xl px-5 pb-20 pt-12">
      <div className="max-w-3xl">
        <p className="text-sm font-semibold uppercase tracking-[0.18em] text-primary">Contact and support</p>
        <h1 className="mt-3 font-heading text-5xl font-semibold leading-tight sm:text-6xl">
          Get the right kind of help.
        </h1>
        <p className="mt-6 text-xl leading-8 text-muted">
          Contact ADarveo for product questions, account help, billing support, cancellation, or refunds.
        </p>
      </div>

      <div className="mt-12 grid gap-5 md:grid-cols-3">
        <article className="rounded-xl border border-border bg-white p-7">
          <Mail className="h-8 w-8 text-primary" />
          <h2 className="mt-5 font-heading text-2xl font-semibold">ADarveo support</h2>
          <p className="mt-3 leading-7 text-muted">
            Product, account, campaign, billing, cancellation, and refund questions.
          </p>
          <a
            className="mt-7 inline-flex items-center gap-2 font-semibold text-primary"
            href={`mailto:${siteDetails.supportEmail}`}
          >
            {siteDetails.supportEmail}
            <ArrowRight className="h-4 w-4" />
          </a>
        </article>

        <article className="rounded-xl border border-border bg-white p-7">
          <ReceiptText className="h-8 w-8 text-primary" />
          <h2 className="mt-5 font-heading text-2xl font-semibold">Paddle buyer support</h2>
          <p className="mt-3 leading-7 text-muted">
            Find a payment, download a receipt, update payment details, cancel, or request a refund.
          </p>
          <a
            className="mt-7 inline-flex items-center gap-2 font-semibold text-primary"
            href="https://paddle.net"
            rel="noreferrer"
          >
            Visit paddle.net
            <ArrowRight className="h-4 w-4" />
          </a>
        </article>

        <article className="rounded-xl border border-border bg-white p-7">
          <LifeBuoy className="h-8 w-8 text-primary" />
          <h2 className="mt-5 font-heading text-2xl font-semibold">Policies</h2>
          <p className="mt-3 leading-7 text-muted">
            Review the subscription, scan-pack, cancellation, and refund terms before purchasing.
          </p>
          <div className="mt-7 flex flex-wrap gap-x-5 gap-y-2 font-semibold text-primary">
            <Link to="/terms">Terms</Link>
            <Link to="/refunds">Refunds</Link>
          </div>
        </article>
      </div>

      <div className="mt-12 rounded-xl bg-[#000210] p-7 text-white sm:p-10">
        <p className="text-sm font-semibold uppercase tracking-[0.16em] text-blue-200">Response times</p>
        <h2 className="mt-3 font-heading text-3xl font-semibold">We aim to reply within two business days.</h2>
        <p className="mt-4 max-w-3xl leading-7 text-white/66">
          Include your account email and Paddle transaction number for billing requests. Never send card
          numbers, passwords, or other sensitive payment information by email.
        </p>
      </div>
    </section>
    <SiteFooter />
  </main>
);
